export const useLandscapeOrientation = () => {};
